import React, { useEffect, useRef } from "react";
import { gsap } from "gsap";
import styles from "./InitialLoadingScreen.module.scss";
import SplitText from "gsap/SplitText";
import { useGSAP } from "@gsap/react";

const InitialLoadingScreen = () => {
  const logoA = useRef();
  const logoB = useRef();
  const logoC = useRef();
  const logoD = useRef();
  const logoE = useRef();
  const maximalSearch = useRef();

  useGSAP(() => {
    gsap.from(logoA.current, {
      y: 100, // move the items up
      opacity: 0, // start with 0 opacity
      stagger: 0.0015, // stagger the appearance of each item
      ease: "power2.out",
      duration: 1,
      delay: 0.5,
    });
    gsap.from(logoB.current, {
      x: 100, // move the items up
      opacity: 0, // start with 0 opacity
      stagger: 0.0015, // stagger the appearance of each item
      ease: "power2.out",
      duration: 1,
      delay: 0.5,
    });
    gsap.from(logoC.current, {
      x: -100, // move the items up
      opacity: 0, // start with 0 opacity
      stagger: 0.0015, // stagger the appearance of each item
      ease: "power2.out",
      duration: 1,
      delay: 0.5,
    });
    gsap.from(logoD.current, {
      y: -100, // move the items up
      opacity: 0, // start with 0 opacity
      stagger: 0.0015, // stagger the appearance of each item
      ease: "power2.out",
      duration: 1,
      delay: 0.5,
    });
    gsap.from(logoE.current, {
      y: -100, // move the items up
      opacity: 0, // start with 0 opacity
      stagger: 0.0015, // stagger the appearance of each item
      ease: "power2.out",
      duration: 1,
      delay: 0.5,
    });

    const splitPlacedIn = new SplitText(maximalSearch.current, {
      type: "words",
    });
    gsap.from(splitPlacedIn.words, {
      opacity: 0,
      x: 10,
      stagger: 0.2,
      duration: 0.5,
      ease: "power3.out",
      delay: 1.5,
    });
  });
  return (
    <div className={styles.loadingPageContainer}>
      <svg
        className={styles.svgLogo}
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 306.53 307.93"
      >
        <g>
          <polygon
            ref={logoA}
            points="117.72 175.31 153.15 193.03 188.6 175.31 188.6 307.93 117.72 307.93 117.72 175.31"
            fill="white"
          />
          <polyline
            ref={logoB}
            points="227.63 307.93 225.03 157.1 306.36 116.44 306.36 307.93"
            fill="white"
          />
          <polyline
            ref={logoC}
            points="0 307.93 0 116.44 81.3 157.09 81.29 307.93"
            fill="white"
          />
          <polyline
            ref={logoD}
            points="146.91 176.43 146.91 73.62 .16 0 .16 101.23"
            fill="white"
          />
          <polyline
            ref={logoE}
            points="159.79 176.43 159.79 73.62 306.53 0 306.53 101.23"
            fill="white"
          />
        </g>
      </svg>
      <div className={styles.maximalSearch} ref={maximalSearch}>
        Maximal Search
      </div>
    </div>
  );
};

export default InitialLoadingScreen;
